//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BreadCrumbs',
  props: {
    title: {
      type: String,
      required: true
    },
    elements: {
      type: Array,
      required: true
    }
  }
}
